<template>
    <div style="background:white; height:100%"> 
        <div style="border-bottom:2px solid #389;padding-top:3px;background:white;display:flex;line-height:30px;height:37px">
            <div style="width:1200px;display:flex">
                <div style="width:70px;display:flex">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" ><div style="font-size:13px;margin-right:15px;width:50px">新增 </div></el-link>
                </div>
                <div style=" font-size:12px;margin-left:10px;width:30px; ">字段</div>
                <el-select v-model="selparam"  placeholder="请选择列名"   size="small" style="width:120px;  ">
                    <span v-for="item in tabArr" :key='item.key' >
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input placeholder="请输入查询值" ref="refqry" @keyup.enter.native="qryTabData" v-model="txtparam" size="small" style="width:300px; height:30px; ">
                    <el-select v-model="oper" slot="prepend" size="small" style="width:90px; ">
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                </el-input> 
 
                <div style=" font-size:12px;margin-left:5px;display:flex;width:150px">
                    <div style="font-size:12px;margin-right:4px;color:red">状态</div>
                    <el-select @change="chkChg" v-model="notAcc" size="small" style="width:110px">
                        <el-option label="所有" value="ALL"></el-option>
                        <el-option label="未记账" value="C"></el-option>
                        <el-option label="审核未记账" value="N"></el-option>
                        <el-option label="审核已记账" value="Y"></el-option>
                    </el-select> 
                </div>
                <el-button :disabled="cfmBool " type="danger" @click="accRec" icon="iconfont icon-fapiaoguanli" size="mini" style="width:70px; height:32px">记账</el-button>
            </div> 
        </div>
        <el-table  :data="tabData" 
                border                            
                disabled-hover
                style="overflow:auto;margin-top:1px;"
                v-loading="loading"
                element-loading-background = "rgba(255, 255, 255, .5)"
                element-loading-text = "加载中，请稍后..."
                element-loading-spinner = "el-icon-loading"
                size="small"
                :cell-style="{padding:'2px'}"
                :header-cell-style="{ 'color':'#389','text-align':'center'}"
                :height="tabHeight" 
                :row-key="getRowKey"  
                header-cell-class-name="clearPadding"
                class="custom-table-border"
                ref="tabref" 
                :row-class-name="tabRowClass"
                @row-click="rowClick"
                highlight-current-row>
            <el-table-column label="序号" type="index" width="60" fixed>
                <el-table-column label="序号" type="index" width="60" fixed>
                    <template slot="header"  >
                        <el-link   @click="rowShow" style="font-size:12px;color:#fff"> 
                            <el-tooltip content=" 清除条件" effect="light">
                                <i class="iconfont icon-shanchu1" style="color:#409eff"></i>
                            </el-tooltip>
                        </el-link>
                    </template>
                    <template slot-scope="scope">
                        <div style="display:flex">
                            {{scope.row['index']+1}} 
                            <div v-if="scope.row['PAYSRC']=='433336'" style="margin-left:4px;font-size:12px;width:20px;height:20px;background:red;color:white;padding-left:4px">代</div>
                        </div>
                    </template>
                </el-table-column>
            </el-table-column>   
            <el-table-column  v-for="(item,index ) in tabArr.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.edcss!=='checkbox'&&item.sortable=='N'"
                :min-width="item.width">
                <el-table-column  resizable :prop="item.key" :label="item.title" show-overflow-tooltip :min-width="item.width">
                    <template slot="header" slot-scope="scope">
                        {{scope.row}}
                        <el-date-picker v-if="item.edcss=='date'" @change="inputQry" size="mini"  type="date" :clearable="false" v-model="v_row[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                         <el-select @change="inputQry" v-else-if="item.key=='STFG'" v-model="v_row[item.key]" size="mini" style="width:100%;">
                            <el-option label="未审核" value="N"></el-option>
                            <el-option label="已审核" value="Y"></el-option>
                        </el-select>
                        <el-select v-else-if="item.key=='ISTAX'" v-model="v_row[item.key]"  size="mini" @change="inputQry" placeholder="请选择"  clearable style="width:100%">
                            <el-option label="不含税" value="N"></el-option>
                            <el-option label="含税" value="Y"></el-option>
                        </el-select> 
                        <el-input type="number" @keyup.enter.native="inputQry" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                        <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="inputQry"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                    </template>
                    <template slot-scope="scope">
                        <el-link v-if="item.key=='IDNO'" :underline="false" @click="repBtn(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;width:100%;text-align:left;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
                        <el-link v-else-if="item.key=='ORDSTFGNM'" :underline="false" @click="stfgBtn(scope.row,scope.$index)"><div style="color:#409eff;border-bottom:1px solid red;width:100%;text-align:left;font-size:10px ">{{scope.row[item.key]}}</div> </el-link>
                        <el-checkbox :disabled="scope.row['STFG']!=='Y'" v-else-if="item.key=='SEL'" v-model="scope.row[item.key]" true-label="Y" false-label="N"></el-checkbox>
                        <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']=='Y'" size="mini" type="" effect="dark">已审核</el-tag>
                        <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']=='N'" size="mini" type="info" effect="dark">未审核</el-tag>  
                        <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']=='K'" size="mini" type="info" effect="dark">已确认</el-tag> 
                        <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']=='P'" size="mini" type="info" effect="dark">审核中</el-tag> 
                        <el-tag  v-else-if="item.key=='ISTAX'&&scope.row['ISTAX']=='Y'" size="mini" type="" effect="dark">含税</el-tag>
                        <el-tag  v-else-if="item.key=='ISTAX'&&scope.row['ISTAX']=='N'" size="mini" type="info" effect="dark">不含</el-tag> 
                        <div v-else v-text="scope.row[item.key]" style="float:left"> </div>
                    </template>
                </el-table-column> 
 
            </el-table-column> 
            <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="220">
                <template slot-scope="scope">                  
                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                    <el-link  @click="editRec(scope.row ,'Y')" :underline="false"  ><span style="font-size:12px;margin-right:5px;">查看</span></el-link> 
                    <span v-if="scope.row.STFG=='N'">
                        <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;margin-left:5px"></i>
                        <el-link :disabled="editBool" @click="editRec(scope.row,'N' )" :underline="false"  ><span style="font-size:12px;margin-right:5px;">编辑</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='N' " >
                        <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;margin-left:5px"></i>
                        <el-link :disabled="editBool|| d_stfg" @click="recSet(scope.row,'K', '确认')" :underline="false"  ><span style="font-size:12px;margin-right:5px;">确认</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='K' " >
                        <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;margin-left:5px"></i>
                        <el-link :disabled="editBool" @click="recSet(scope.row,'N', '弃认')" :underline="false"  ><span style="font-size:12px;margin-right:5px;">弃认</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG=='K'">
                        <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;margin-left:5px"></i>
                        <el-link :disabled="cfmBool" @click="recSet(scope.row,'Y','审核')" :underline="false"  ><span style="font-size:12px;margin-right:5px;">审核 </span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='Y'">
                        <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;margin-left:5px"></i>
                        <el-link :disabled="cfmBool" @click="recSet(scope.row,'N','弃审')" :underline="false"  ><span style="font-size:12px;margin-right:5px;">弃审 </span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='N'">
                        <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link  @click="tabDel(scope.row ,scope.$index)" :underline="false"  ><span style="font-size:12px; ">删除</span></el-link>
                    </span>
                </template>
            </el-table-column>  
        </el-table>  
        <div style=" margin-top:2px;overflow: hidden;display:flex;background:white;font-size:12px ;padding-left:4px">
            <div style="float: left;font-size:12px">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="color:#606266;margin:7px 10px;font-size:12px;width:35px;">每页</div>
            <el-select v-model="rowSize" size="small" style="width:80px;"  @change="initPage">
                <el-option 
                    v-for="item in pageList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </div> 
        <!-- 提示框 -->
        <el-dialog  :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 数据查看 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="addWin" :width="dlgWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:89vh;overflow-y:auto">
                <Form ref="addForm" :model="formCol" :label-width="120"  :rules="ruleValidate"  label-position="right" inline >
                    <span v-for="(item,index) in tabArr" :key="index" >
                        <FormItem :class="item.key=='REASON'?'item-width2':'item-width'"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                            <el-checkbox size="medium" border v-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="formCol[item.key]" style="width:100%"></el-checkbox> 
                            <el-input  size="medium" type="textarea" :rows="2"  v-else-if="item.key==='REASON'"   v-model="formCol[item.key]"></el-input> 
                            <el-select size="medium" @change="selectChg(item.key)" :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="formCol[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
                            <el-date-picker size="medium" type="month" @change="yrChange(formCol)" v-else-if="item.key==='YRMTH'" v-model="formCol[item.key]" clearable value-format="yyyy-MM" style="width:100%" ></el-date-picker> 
                            <el-select size="medium" filterable @change="empChg" v-else-if="item.key==='EMPNO' " v-model="formCol[item.key]"   style="width:100%">
                                <el-row v-for="(item ,index) in empArr " :key="index">
                                    <el-col :span="4">
                                        <el-option  :label="item.TY" :value="item.EMPNM"></el-option>
                                    </el-col>
                                    <el-col :span="10">
                                        <el-option  :label="item.DEPTNM" :value="item.EMPNM"></el-option>
                                    </el-col>
                                    <el-col :span="10">
                                        <el-option  :label="item.EMPNM" :value="item.EMPNM"></el-option>
                                    </el-col>
                                </el-row>
                            </el-select>
                            <el-select v-else-if="item.key==='ISTAX'" v-model="formCol[item.key]" size="medium" style="width:100%">
                                <el-option label="含税" value="Y"></el-option>
                                <el-option label="不含税" value="N"></el-option>
                            </el-select> 
                            <el-date-picker size="medium" type="date"  v-else-if="item.edcss==='date'" v-model="formCol[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>    
                            <el-input-number size="medium" controls-position="right" v-else-if="item.edcss==='number'"  style="width:100%" v-model="formCol[item.key]"></el-input-number> 
                            <el-input size="medium" :placeholder="item.holder" type="text" v-else  :disabled="item.disabled==='Y'?true:false||saveFlag||(item.key=='FINVNO'&&hapBool)"  v-model="formCol[item.key]"></el-input>
                        </FormItem>
                    </span>
                </Form>
                <div style="background:#808695;border-left:2px solid #409eff;line-height:30px;color:white;padding-left:10px;font-size:14px"> 报销费用明细【
                   <i class="iconfont icon-xinzeng" style="color:#fff;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="saveFlag"  @click="addDtl" :underline="false" ><span style="font-size:12px;margin-right:5px;color:white">新增记录</span></el-link> 
                    】
                </div>  
                <el-table  :data="dtlData" 
                        border                            
                        disabled-hover
                        class="custom-table-border"
                        size="small"
                        style="overflow:auto;margin-top:1px;"
                        :height="dtlHeight" 
                        :cell-style="{padding:'2px'}"
                        :row-key="getDtlKey"  
                        show-summary
                        :summary-method="getSummary"
                        ref="dtlref" 
                        highlight-current-row>
                    <el-table-column type="index" label="序号" width="60" fixed></el-table-column>    
                    <span v-for="(item,index ) in dtlArr" :key="index">
                        <el-table-column  v-if="item.thide==='N' &&item.edcss!=='checkbox'&&item.key!=='PAYIDNO' && item.key!=='PATH'"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                    
                            sortable
                            :min-width="item.width">
                        </el-table-column> 
                        <el-table-column  v-if="item.edcss=='checkbox'&&item.key!=='SEL'"
                            :prop="item.key"
                            :label="item.title"
                            :align="item.align"                                  
                            width="80">
                            <template slot-scope="scope">
                                <el-checkbox  disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            </template>
                        </el-table-column>
                        <el-table-column  v-if="item.key=='PAYIDNO'"
                            :prop="item.key"
                            :label="item.title"
                            align="center"
                            show-overflow-tooltip                                  
                            width="105">
                            <template slot-scope="scope" >
                                <el-link  :underline="false" @click="seeDay(scope.row[item.key])"><div style="color:#409eff;border-bottom:1px solid red ">{{scope.row[item.key]}}</div> </el-link>
                            </template>
                        </el-table-column>
                        <el-table-column  v-if="item.key=='PATH'"
                            :prop="item.key"
                            :label="item.title"
                            align="center"
                            show-overflow-tooltip                                  
                            width="80">
                            <template slot-scope="scope" >
                                <el-link  :underline="false" @click="seeLink(scope.row[item.key])"><div style="color:#409eff;border-bottom:1px solid red ">{{scope.row[item.key]}}</div> </el-link>
                            </template>
                        </el-table-column>
                    </span>
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="170">
                        <template slot-scope="scope">
                            <i class="iconfont icon-shangchuan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link  @click="upImg(scope.row,scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">图片</span></el-link>
                            <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="typeof(scope.row['PAYIDNO'])=='string'"  @click="dtlEdit(scope.row ,scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">编辑</span></el-link>
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="typeof(scope.row['PAYIDNO'])=='string'" @click="dtlDel(scope.row ,scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:2px;">删除</span></el-link>
                        </template>
                    </el-table-column>  
                </el-table>  
                <!-- 单据明细 -->
                <div style="background:#808695;border-left:2px solid #409eff;line-height:30px;color:white;padding-left:10px;font-size:14px"> 费用摊分明细  【
                    <el-select size="small" v-model="billType" style="width:180px">
                        <el-option v-for="(item,index) in tyArr" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                    </el-select>
                    <i class="iconfont icon-xinzeng" style="color:#fff;font-size:14px;margin-right:5px;margin-left:10px;"></i>
                    <el-link :disabled="saveFlag" @click="addList" :underline="false" ><span style="font-size:12px;margin-right:5px;color:white">关联单据</span></el-link> 
                    <i class="iconfont icon-fenzhijiedian" style="color:#fff;font-size:14px;margin-right:5px;margin-left:20px;"></i>
                    <el-link :disabled="saveFlag" @click="disFee" :underline="false" ><span style="font-size:12px;margin-right:5px;color:white">分摊费用</span></el-link>              
                    】
                </div> 
                <el-table  :data="listData" 
                        border                            
                        disabled-hover
                        style="overflow:auto;margin-top:1px;"
                        size="small"
                        :height="200" 
                        :cell-style="{padding:'2px'}"
                        :row-key="getListKey"  
                        show-summary
                        :summary-method="getListSum"
                        ref="listref" 
                        class="custom-table-border"
                        highlight-current-row>
                    <el-table-column type="index" width="60" label="序号" fixed ></el-table-column>  
                    <span v-for="(item,index ) in listArr" :key="index">
                        <el-table-column  v-if="item.thide==='N'  "
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            sortable
                            :min-width="item.width">
                        </el-table-column> 
                    </span>
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="75">
                        <template slot-scope="scope">
                             
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link  @click="listDel(scope.row ,scope.$index)" :underline="false"  ><span style="font-size:12px; ">删除</span></el-link>
                        </template>
                    </el-table-column>  
                </el-table>  
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <span :style="stfgColor">
                        <i class="iconfont" :class="stfgCss"  style="font-size:30px; margin-left:40px;margin-right:70px;height:35px;vertical-align:middle"></i>
                    </span>
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addWin=false" style="margin-right:25px;">取消</el-button>
                    <el-button :disabled="saveFlag" type="primary" size="small" icon="iconfont icon-baocun"  @click="saveRec" style="margin-right:10px;">保存</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 明细表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="dtlWin" :width="dlgWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{addFlag=='create'?'新增记录':'编辑记录'}}</span>
            </div> 
            <Form  :model="dtlCol" :label-width="120"  :rules="dtlValidate" label-position="right" inline >
                <span v-for="(item,index) in dtlArr" :key="index" >
                    <FormItem :class="item.key=='REASON'?'item-width2':'item-width'"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                        <el-checkbox border v-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="dtlCol[item.key]" style="width:100%"></el-checkbox> 
                        <el-input   type="textarea" :rows="2"  v-else-if="item.key==='REASON'"   v-model="dtlCol[item.key]"></el-input> 
                        <el-select filterable :disabled="saveFlag||item.disabled=='Y'" v-else-if="item.edcss==='select'" v-model="dtlCol[item.key]"   style="width:100%">
                            <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                        </el-select>
                        <el-select :disabled="saveFlag" v-else-if="item.key==='DISTY'" v-model="dtlCol[item.key]"  @change="disChg" style="width:100%">
                            <el-option v-for="(item,index) in disArr " :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                        </el-select>
                        <el-select filterable  :disabled="saveFlag" v-else-if="item.key==='ACNO'" v-model="dtlCol[item.key]"  @change="acChg" style="width:100%">
                            <el-row v-for="(item ,index) in subArr " :key="index">
                                <el-col :span="6">
                                    <el-option  :label="item.IDNO" :value="item.IDNO"></el-option>
                                </el-col>
                                <el-col :span="18">
                                    <el-option  :label="item.CNAME" :value="item.IDNO"></el-option>
                                </el-col>
                            </el-row>
                            <!-- <el-option
                                v-for="(item ,index) in subArr " :key="index" :label="item.CNAME" :value="item.IDNO">
                                <span style="float: left">{{ item.CNAME }}</span>
                                <span style="float: right; color: #8492a6; font-size: 12px">{{ item.IDNO }}</span>
                            </el-option> -->
                        </el-select>
                        <el-select :disabled="saveFlag" v-else-if="item.key==='DEPTNO'" v-model="dtlCol[item.key]"  @change="deptChg" style="width:100%">
                            <el-option v-for="(item,index) in deptArr " :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                        </el-select>
                        <el-date-picker type="date"  v-else-if="item.edcss==='date'" v-model="dtlCol[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>    
                        <el-input-number controls-position="right" v-else-if="item.edcss==='number'"  style="width:100%" v-model="dtlCol[item.key]"></el-input-number> 
                        <el-input :placeholder="item.holder" type="text" v-else  :disabled="item.disabled==='Y'?true:false||saveFlag"  v-model="dtlCol[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="dtlWin=false" style="margin-right:25px;">取消</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-chenggong1"  @click="dtlSave" style="margin-right:10px;">确定</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 引用单据-->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="refWin" :width="dlgWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">分摊关联单据明细</span>
            </div> 
            <div style="border-bottom:2px solid #389;margin-top:-2px;background:white; ">
 
                <el-checkbox border size="small"  @change="selChg"  v-model="selAll" true-label="Y"  false-label="N"><span style="font-size:12px;margin-left:5px;color:#389">全选</span></el-checkbox>
                <el-select v-model="selparam3"  placeholder="请选择列名" clearable size="small" style="width:130px;margin-left:15px; ">
                    <span v-for="item in refArr" :key='item.key'>
                        <el-option v-if="item.thide=='N'" :label="item.title" :value="item.key"></el-option>
                    </span>
                </el-select>
                <el-input placeholder="请输入查询值" ref="refqry" v-model="textparam3" size="small" style="width:340px;height:30px; ">
                    <el-select v-model="oper3"  size="small" slot="prepend" style="width:110px;  ">
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button slot="append" icon="el-icon-search" @click="qryRefData" style="color:#409eff"></el-button>
                </el-input>  
                <el-button @click="cfmSave" style="margin-left:15px" icon="iconfont icon-chenggong1" type="primary" size="mini">确定选择</el-button>  
            </div>
            <div style="height:89vh;overflow-y:auto">
                <el-table  :data="refData" 
                        border                            
                        disabled-hover
                        :cell-style="{padding:'2px'}"
                        style="overflow:auto;margin-top:1px;"
                        size="small"
                        :min-height="200" 
                        class="custom-table-border"
                        :row-key="getRefKey"  
                        ref="refjoin" 
                        highlight-current-row>
                    <el-table-column type="index" width="60" label="序号" fixed ></el-table-column>  
                    <span v-for="(item,index ) in refArr" :key="index">
                        <el-table-column  v-if="item.thide==='N' &&item.edcss!=='checkbox' "
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            sortable
                            :min-width="item.width">
                        </el-table-column>
                        <el-table-column  v-if="item.edcss=='checkbox' "
                            :prop="item.key"
                            :label="item.title"
                            :align="item.align"                                  
                            width="80">
                            <template slot-scope="scope">
                                <el-checkbox  true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            </template>
                        </el-table-column> 
                    </span>
                </el-table>
            </div>
        </el-dialog>
        <!-- 上传图片-->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="imgWin" width="1200" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">上传图片</span>
            </div> 
            <div style="line-height:30px;border-bottom:2px solid #389;margin-top:5px;background:white"><i class="iconfont icon-xinxi" style="margin-right:4px"></i>最多上传6张图片(可以是图片格式或PDF格式）</div>
            <div style="display:flex;margin-top:15px;" >
                <Upload
                    ref="upload"
                    name="upfile"
                    :data="uploadData"
                    :show-upload-list="false"
                    :before-upload="beforeImgFile"
                    :on-success="successImgFile"
                    :on-progress="handleProgress"
                    :with-credentials="true"                            
                    :max-size="10240"
                    :on-exceeded-size="handleMaxSize"
                    :format="['jpg','jpeg','png','gif','bmp','tiff','pdf' ]"
                    :on-format-error="handleFormatError"
                    type="drag"
                    :action="uploadUrl"
                    style="display: inline-block;width:200px; ">                           
                    <div style="padding: 1px 0;width:200px;height:150px;">
                        <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                        <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                    </div>                                                       
                </Upload> 
                <div style="display:flex;margin-left:30px;height:440px;flex-wrap:wrap"  >
                    <div v-if="FILEPATH" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="FILEPATH &&FILEPATH.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div>
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH]" style="width:200px;height:150px;" :src="FILEPATH">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <!-- <i class="el-icon-picture-outline" style="font-size:100px"></i> -->
                                <span style="color:red;font-weight:700;font-size:14px">显示错误</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(0)"><Icon type="md-close" /> 删除</el-link>
                            <el-link :underline="false" @click="imgPreview( FILEPATH)"><Icon type="ios-search" /> 预览</el-link>
                        </div>
                    </div>
                    <div v-if="FILEPATH2" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;"> 
                        <div v-if="FILEPATH2 &&FILEPATH2.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH2" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div> 
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH2]" style="width:200px;height:150px;" :src="FILEPATH2">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">图片未上传</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(1) "><Icon type="md-close" /> 删除</el-link>
                            <el-link :underline="false" @click="imgPreview( FILEPATH2)"><Icon type="ios-search" /> 预览</el-link>
                        </div>
                    </div>
                    <div v-if="FILEPATH3" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="FILEPATH3 &&FILEPATH3.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH3" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div> 
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH3]" style="width:200px;height:150px;" :src="FILEPATH3">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">图片未上传</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(2) "><Icon type="md-close" /> 删除</el-link>
                            <el-link :underline="false" @click="imgPreview( FILEPATH3)"><Icon type="ios-search" /> 预览</el-link>
                        </div>
                    </div>
                    <div v-if="FILEPATH4" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="FILEPATH4 &&FILEPATH4.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH4" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div> 
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH4]" style="width:200px;height:150px;" :src="FILEPATH4">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">图片未上传</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(3) "><Icon type="md-close" /> 删除</el-link>
                            <el-link :underline="false" @click="imgPreview( FILEPATH4)"><Icon type="ios-search" /> 预览</el-link>
                        </div>
                    </div>
                    <div v-if="FILEPATH5" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="FILEPATH5 &&FILEPATH5.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH5" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div> 
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH5]" style="width:200px;height:150px;" :src="FILEPATH5">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">图片未上传</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(4) "><Icon type="md-close" /> 删除</el-link>
                            <el-link :underline="false" @click="imgPreview( FILEPATH5)"><Icon type="ios-search" /> 预览</el-link>
                        </div>
                    </div>
                    <div v-if="FILEPATH6" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="FILEPATH6 &&FILEPATH6.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH6" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div> 
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH6]" style="width:200px;height:150px;" :src="FILEPATH6">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">图片未上传</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(5) "><Icon type="md-close" /> 删除</el-link>
                            <el-link :underline="false" @click="imgPreview( FILEPATH6)"><Icon type="ios-search" /> 预览</el-link>
                        </div>
                    </div>
                </div> 
            </div>
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <el-dialog v-dialogDrag :visible.sync="showViewer" width="800px" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">预览</span>
            </div>
            <el-image fit="scale-down"  style=" margin:5px auto;height:500px;width:100% " :src="listurl"></el-image>
        </el-dialog>
        <!-- 链接图片预览 -->
        <el-dialog v-dialogDrag :visible.sync="linkWin" width="1200px" append-to-body :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">预览</span>
            </div>
            <div style="display:flex;width:1150px;flex-wrap:wrap">
                <div v-for="(item,index) in linkArr" :key="index" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px; ">    
                    <div v-if="item &&item.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                        <iframe :src="item" frameborder="0" style="width: 100%; height: 100%"></iframe>
                    </div>
                    <el-image v-else fit="fill" :preview-src-list="[item]" style="width:200px;height:150px;" :src="item"></el-image>
                    <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                        <el-link   :underline="false" @click="downFile(item) "><i class="iconfont icon-xiazai" style="font-size:12px"> 下载</i> </el-link>
                        <el-link :underline="false" @click="imgPreview( item)"><i class="iconfont icon-chakan1" style="font-size:12px"> 预览</i></el-link>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 分摊费用 -->
        <el-dialog v-dialogDrag :visible.sync="disWin" width="450px" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">分摊方式</span>
            </div>
            <div style="display:flex">
                <div style="width:100px;line-height:30px">分摊方式</div>
                <el-select size="middle" v-model="feeMth" style="width:280px">
                    <el-option v-for="(item,index) in feeArr" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                </el-select>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:20px ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="disWin=false" style="margin-right:25px;">取消</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-chenggong1"  @click="feeSave" style="margin-right:10px;">确定</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 记账 -->
        <el-dialog v-dialogDrag :visible.sync="accWin" width="1220px" append-to-body :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记账费用</span>
            </div>
            <div style="height:30px;line-height:30px;background:#f1f2f3;color:red;border-left:3px solid #389;padding-left:5px">
                 提示：当费用记录已记账后，则不再显示
            </div>
            <div style="height:30px;line-height:30px;background:#fff; ">
                <el-checkbox border size="small"  @change="chkSel"  v-model="v_all" true-label="Y"  false-label="N"><span style="font-size:12px;margin-left:5px;color:#389">全选</span></el-checkbox>
            </div>
            <div style="display:flex;overflow-y:auto;max-height:88vh;width:100%">
                <div v-if="stepFlag">
                    <el-table  :data="bankData" 
                            border                            
                            disabled-hover
                            :cell-style="{padding:'2px'}"
                            style="overflow:auto;margin-top:1px; width:1200px"
                            size="small"
                            :height="300" 
                            :row-key="getDtlKey"  
                            class="custom-table-border"
                            show-summary
                            :summary-method="getSummary"
                            ref="bankref" 
                            highlight-current-row>
                        <el-table-column type="index" label="序号" width="60" fixed></el-table-column>    
                        <span v-for="(item,index ) in dtlArr" :key="index">
                            <el-table-column  v-if="item.thide==='N' &&item.edcss!=='checkbox' "
                                :prop="item.key"
                                :label="item.title"
                                show-overflow-tooltip
                                :align="item.align"                                  
                                sortable
                                :min-width="item.width">
                            </el-table-column> 
                            <el-table-column  v-if="item.edcss=='checkbox'||item.key=='SEL' "
                                :prop="item.key"
                                :label="item.title"
                                :align="item.align"                                  
                                width="80">
                                <template slot-scope="scope">
                                    <el-checkbox  :disabled="item.key!=='SEL'" true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                                </template>
                            </el-table-column>
                        </span>
                    </el-table>  
                </div>
                <span v-if="!stepFlag">
                    <bank-day ref="refbank" @child-save="finSave" @child-exit="finExit"></bank-day>
                </span>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:20px ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="accWin=false" style="margin-right:25px;">取消</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-xiayiyehouyiye"  @click="nextStep" style="margin-right:10px;">下一步</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 明细表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="dayWin" :width="dlgWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">日记账明细 </span>
            </div> 
            <div style="height:85vh;overflow-y:auto" >
                <tmpl-bank ref="refday"></tmpl-bank>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表参数</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="dlgWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
    </div>  
</template>
<script>
import bankDay from './inv_bankday.vue' 
import tmplBank from './tmpl_bankday.vue'
import { getTabColOrData,getBaseData } from '../../api/user';
import {getDate, getDate2,getLastDay} from '../../api/Select' 
import FileSaver from 'file-saver'
import repWin from '../datamgt/repWin.vue' 
import { startWorkflowInstance } from '@/utils/workflowDesigner.js'
//局部注册
export default {
    name:"seyas_pay",
    data () {
        return {
            dataCount:0,
            rowSize:50,
            current:1,
            v_all:'N',
            pageList: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            allData:[],
            stepFlag:true,
            dayWin:false,
            feeMth:'',
            linkWin:false,
            bankData:[],
            feeArr:[],
            disWin:false,
            delImg:[],
             
            v_idseq:'',
 
            notAcc:'C',
            uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
            Accept: "png,jpg,jpeg,gif,pdf", //上传文件格式限制
            videoUploadPercent:0,
            videoFlag:false,
            uploadData:{}, //上传数据
            imgWin:false,
            selAll:'N',
            refData:[],
            refWin:false,
            billType:'',
            dtlWin:false,
            dtlCol:{},
            loading:false,
            addWin:false,
            operArr:[],
            addFlag:'create',
            saveFlag:false,
            promptWin:false,
            prompt:'',
            stfgCss:'',
            stfgColor:'',
            oper:'like',
            d_stfg:false,
            FILEPATH:'',
            FILEPATH2:'',
            FILEPATH3:'',
            FILEPATH4:'',
            FILEPATH5:'',
            FILEPATH6:'',
            selparam:'DTTM',
            oper3:'like',
            selparam3:'IDNO',
            textparam3:'',
            disabled:false, //新增权限制
            txtparam:'',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            formCol: {},
            tabData:[], //表数据
            tabArr:[], //表列
            dtlArr:[],
            dtlData:[],
            listArr:[],
            listData:[],
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getTableRecMany' , 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            comboArr:[],
            notNull:[],
            notDtl:[],
            delArr:[],
            ruleValidate:{},
            dtlValidate:{},
            dtlFlag:'create',
            rowIndex:'',
            empArr:[],
            v_stfg:'',
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            deptArr:[],
            disArr:[],
            tyArr:[],
            refArr:[],
            v_view:'',
            options:[],
            v_type:'',
            delData:[],
            subArr:[],
            listurl:'',
            showViewer:false,
            accWin:false,
            linkArr:[],
            repDlg:false,
            v_rowRec:{},
            v_idno:'',
            hapBool:false,
            v_replist:[],
            repArr:[],
            repWin:false,
            repUrl:'',
            v_commit:true,
            v_data:[],
            v_row:{},
        }
    },
    mounted () { 

        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','227450','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        //用户表单新增、编辑、审核、作废权限  
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','227450','v_sys_user_priv',' and issel=\'Y\'').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                if (res.result.length>0){
                    let row =res.result[0]
                    if (row.ISADD==='N'){ //新增
                        this.addBool=true
                    }if (row.ISUPD==='N'){ //修改
                        this.editBool=true
                    }if (row.ISDEL==='N'){ //删除
                        this.delBool=true
                    }if (row.ISCFM==='N'){ //审核
                        this.cfmBool=true
                    }if (row.ISCANCEL==='N'){ //作废
                        this.cancelBool=true
                    }
                }
            }
        })  
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','227450','LSTSEQ','2','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','227450','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notDtl = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.dtlValidate =ruleObj
        })
        //操作符
        getBaseData(this.v_formurl,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        getBaseData(this.v_formurl,'corpid',this.v_corpid,'','','V_FEE_EMP','').then(res=>{
            this.empArr =res.result
        })
        getBaseData(this.v_formurl,'corpid',this.v_corpid,'','','hr_frame','').then(res=>{
            this.deptArr =res.result
        })
        getBaseData(this.v_formurl,'corpid',this.v_corpid,'','','V_SUBJECT_COMBO','').then(res=>{
            this.subArr =res.result
            this.options =res.result
        })
        getBaseData(this.v_formurl,'PARENTNO','228806','','','v_sys_base','').then(res=>{
            this.disArr =res.result
        })
        getBaseData(this.v_formurl,'PARENTNO','230797','','','v_sys_base','').then(res=>{
            this.feeArr =res.result
        })
        getBaseData(this.v_formurl,'PARENTNO','228812','','','v_sys_base','').then(res=>{
            this.tyArr =res.result
        })
        this.comSelect()
        
    },
    computed: {
        dlgWidth: function() {
            return (window.innerWidth - 100) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 155) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 630) + 'px';
        },
    },
    components: {
        bankDay,
        tmplBank,
        repWin,
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.chkChg(this.notAcc)
            this.getTabField() //表列字段
 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
        
    },
    methods: {
        yrChange(row){
            let v_day =0
            if (row['DAYS'] && Number(row['DAYS'])>0){
                v_day =Number(row['DAYS'])
            }
            let v_dttm =getLastDay(row['YRMTH'],v_day)
            this.$set(this.formCol,'PAYDTTM',v_dttm)
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.getTabList('')
        } ,
        //字段查询
        inputQry(){
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabArr.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_cond ){
                        if (v_edcss =='number'){
                            v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }else{
                        if (v_edcss =='number'){
                            v_cond = ' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond = ' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }
                }
            })
            this.getTabList(v_cond)
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt ='请选择报表'
            }else{
                this.repWin =true
                this.repDlg =false
                if (this.v_rowRec['REFIDTY']=='STK'){ //以发票为主线
                    this.repUrl =this.$store.state.repUrl+ 'rep_payable.cpt'+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO']+'&p_userid='+this.v_username+getDate('full')
                }else if (this.v_rowRec['REFIDTY']=='OUT'){ //以发票为主线
                    this.repUrl =this.$store.state.repUrl+ 'out_payable.cpt'+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO']+'&p_userid='+this.v_username+getDate('full')
                }else{
                    this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO']+'&p_userid='+this.v_username+getDate('full')
                }
 
            }
        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
            this.v_rowRec =JSON.parse(JSON.stringify(row))
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current=index
            this.tabData = this.allData.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
        },
        downFile(item){
            const arr_name=filePath.split("/")
            const file_name=arr_name[arr_name.length-1] //获取文件名
            FileSaver.saveAs(filePath,file_name) 
        },
        //链接详情
        seeLink(val){
            this.linkWin =true
            this.linkArr =val.split(',').filter(item=>{
                return item !==''
            })
        },
        chkChg(val){
            if (val=='N'){
                this.getFeeList(' and idseq in (select idseq from V_FIN_FEEDTL where stfg=\'Y\' and payidno is null)')
            }else if (val=='Y'){
                this.getFeeList(' and idseq in (select idseq from V_FIN_FEEDTL where stfg=\'Y\' and payidno is not null)')
            }else if (val=='C'){
                this.getFeeList(' and idseq not in (select idseq from V_FIN_FEEDTL where stfg=\'Y\' and payidno is not null)')
            }else{
                this.getFeeList('')
            }
        },
        seeDay(idseq){
            this.dayWin =true
            this.$nextTick(()=>{
                this.$refs['refday'].initData(idseq)
            })
        },
        finExit(){
            this.accWin =false
            this.stepFlag =true
        },
        finSave(idseq){
            this.accWin =false
            this.stepFlag =true
            this.getDtlData(this.v_idseq)
        },
        //记账
        accRec(){
            this.v_data=[]
            this.v_all ='N'
            this.tabData.forEach(item=>{
                if (item['SEL']=='Y'){
                    this.v_data.push(JSON.parse(JSON.stringify(item)))
                }
            })
            if (this.v_data.length ==0){
                this.promptWin =true
                this.prompt ='请选择需要记账的单据'
            }else{
                this.accWin =true
                this.bankData=[]
                //选择记录
                this.v_data.forEach(item=>{
                    this.$axios({   
                        method: 'post',
                        url:'xuper_auth/getBaseData',
                        data: {p_key:'idseq', p_value:item['IDSEQ'], p_cond: ' order by lstseq' ,p_table:'V_FIN_FEEDTL'},
                    }).then(res=>{ 
                        res.result.forEach(it=>{  
                            if (!it['PAYIDNO']){
                                this.bankData.push(it)
                            }
                        })
                        this.$nextTick(()=>{
                            this.$refs['bankref'].doLayout()
                        })
                        
                    })
                })
            } 
        },
        filterableData(val){
            let result =[]
            if (val ){
                this.options.forEach(item=>{
                    if (item['IDNO'].indexOf(val)>-1||item['CNAME'].indexOf(val)>-1){
                        result.push(item)
                    } 
                })
                this.subArr =result
            }else{
                this.subArr =this.options
            }
        },
        //图片预览
        imgPreview(path){
            if (path &&path.lastIndexOf('.pdf')>-1){
                let routeUrl = this.$router.resolve({
                    path: '/fullPreview',
                    query: {fileUrl: path},
                });
                window.open(routeUrl.href, '_blank');
            }else{
                this.showViewer=true
                this.listurl=path
            }
        },
        imgDel( index){
            this.$confirm('你确定要删除此图片吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                if (index==0){
                    this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH:''}) )
                    this.FILEPATH =''
                }else if (index==1){
                    this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH2:''}) )
                    this.FILEPATH2=''
                }else if (index==2){
                    this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH3:''}) )
                    this.FILEPATH3=''
                }else if (index==3){
                    this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH4:''}) )
                    this.FILEPATH4=''
                }else if (index==4){
                    this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH5:''}) )
                    this.FILEPATH5=''
                }else if (index==5){
                    this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH6:''}) )
                    this.FILEPATH6=''
                }
                               
            }).catch(()=>{})
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        handleFormatError (file) {
            this.promptWin =true
            this.prompt='文件格式错误,'+file.name + ' 是不正确, 请选择 jpg,jpeg,png,gif,bmp,tiff'
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + ' 文件太大, 不能超出10M' 
        },
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
             
            let v_filename=this.$store.state.nasUrl+res.result 
       
            if (!this.FILEPATH ){
                this.FILEPATH =v_filename
                this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH:v_filename}) )             
            }else if (!this.FILEPATH2 ){
                this.FILEPATH2 =v_filename
                this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH2:v_filename}) )             
            }else if (!this.FILEPATH3 ){
                this.FILEPATH3 =v_filename
                this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH3:v_filename}) )             
            }else if (!this.FILEPATH4 ){
                this.FILEPATH4 =v_filename
                this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH4:v_filename}) )             
            }else if (!this.FILEPATH5){
                this.FILEPATH5 =v_filename
                this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH5:v_filename}) )             
            }else if (!this.FILEPATH6 ){
                this.FILEPATH6 =v_filename
                this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH6:v_filename}) )             
            } 
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile (res, file) {
            this.fileName= this.v_username+getDate('year')   
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise;
  
        },
 
        upImg(row,index){
            this.imgWin =true
            this.rowIndex =index
            this.FILEPATH =row['IMGPATH']
            this.FILEPATH2 =row['IMGPATH2']
            this.FILEPATH3 =row['IMGPATH3']
            this.FILEPATH4 =row['IMGPATH4']
            this.FILEPATH5 =row['IMGPATH5']
            this.FILEPATH6 =row['IMGPATH6']
            this.dtlCol=JSON.parse(JSON.stringify(row))
        },
        //确定选择 所关联记录
        cfmSave(){
            let arr =[]
            this.refData.forEach(item=>{
                if (item['SEL']=='Y'){
                    let obj ={}
                    let v_pkseq =item['IDSEQ']+'-'+item['LSTSEQ']
                    Object.assign(obj,{SKUNO:item['SKUNO'],REFTYNM:item['REFTYNM'],REFIDNO:item['IDNO'],REFDTTM:item['ORDDTTM'],MATNO:item['MATNO'],MATNM:item['MATNM'],MATDESC:item['MATDESC'],QTY:item['QTY'],PRC:item['PRC'],BOXCUBE:item['BOXCUBE'],REFIDSEQ:item['IDSEQ'],REFLSTSEQ:item['LSTSEQ']})
                    let bool =true
                    //判断是否存在添加 
                    this.listData.some(item=>{
                        if (item['REFIDSEQ']+'-'+item['REFLSTSEQ'] ==v_pkseq){
                            bool =false
                        }
                    })
                    if (bool){
                        arr.push(obj)
                    }
                }
            })
            //console.log(JSON.stringify(arr))
            if (arr.length >0){
                arr.forEach(item=>{
                    this.listData.push(item)
                }) 
            }
            this.refWin=false
            this.$nextTick(() => { //有固定列时 查询后重新布局
                this.$refs.listref.doLayout();
            })
        },
        chkSel(){
            if(this.v_all =='Y'){
                this.bankData.forEach(item=>{
                    Object.assign(item ,{SEL:'Y'})
                })
            }else{
                this.bankData.forEach(item=>{
                    Object.assign(item ,{SEL:'N'})
                })
            }

        },
        //
        selectChg(key){
            if (key =='HAPPEN'){
                
                if (this.formCol['HAPPEN']=='407503'){
                    this.hapBool =true
                }else{
                    this.hapBool =false
                }
                if (this.formCol['FINVNO']){
                    this.formCol['FINVNO']=''
                }
            }
        },
        selChg(){
            if(this.selAll =='Y'){
                this.refData.forEach(item=>{
                    Object.assign(item ,{SEL:'Y'})
                })
            }else{
                this.refData.forEach(item=>{
                    Object.assign(item ,{SEL:'N'})
                })
            }
        },
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='CHKAMT'||column.property==='ACTPAY'){
                    let v_sum =values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) )
                        }else{
                            return prev
                        }
                    },'')
                    if (v_sum){
                        sums[index] =v_sum.toLocaleString()
                    }else{
                        sums[index]=''
                    }
                }
            })
            return sums
        },
        getListSum(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='DISAMT'||column.property==='AMT'|| column.property==='QTY'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(1)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        deptChg(val){
            this.deptArr.some(item=>{
                if (item['CODE']==val){
                    Object.assign(this.dtlCol,{DEPTNM:item['CNAME']})
                }
            })
        },
        disChg(val){
            this.disArr.some(item=>{
                if (item['CODE']==val){
                    Object.assign(this.dtlCol,{DISTYNM:item['CNAME']})
                }
            })
        },
        acChg(val){
            this.subArr.some(item=>{
                if (item['IDNO']==val){
                    Object.assign(this.dtlCol,{ACNM:item['CNAME']})
                }
            })
        },
        empChg(val){
            this.formCol['DEPTNO']=''
            this.formCol['BANKADDR']=''
            this.formCol['BANKNO']=''
            this.formCol['BANKNM']=''
            this.formCol['RCVER']=''
            this.formCol['DAYS']=0
            this.empArr.some(item=>{
                if(item['EMPNM']==val){
                    this.formCol['DEPTNO']=item['DEPTNM']
                    this.formCol['BANKADDR']=item['BANKADDR']
                    this.formCol['BANKNO']=item['BANKNO']
                    this.formCol['BANKNM']=item['BANKNM']
                    this.formCol['RCVER']=item['PAYNM']
                    this.formCol['DAYS']=item['DAYS']
                }
            })
        },
        disFee(){
            this.disWin =true
        },
        //下一步
        nextStep(){
            let selArr =[]
            this.bankData.forEach(item=>{
                let obj={}
                if (item['SEL']=='Y'){
                    Object.assign(obj,item,{IDSEQ:'',LSTSEQ:'',REFIDSEQ:item['IDSEQ'],REFLSTSEQ:item['LSTSEQ']  })
                    selArr.push(obj)
                }
            })
            if (selArr.length>0){
                this.stepFlag =false
                this.$nextTick(()=>{
                    this.$refs['refbank']['v_acno']='15911'
                    this.$refs['refbank']['v_word']='4260'
                    this.$refs['refbank']['v_orgnm']=this.formCol['EMPNO']
                    this.$refs['refbank']['spFlag'] =false
                    this.$refs['refbank'].addRec()
                    this.$refs['refbank'].feeData =selArr
                })
            }else{
                this.promptWin =true
                this.prompt ='请选择需要记账的记录'
            }
        },
        //分摊费用
        feeSave(){
            if (!this.feeMth ){
                this.promptWin =true
                this.prompt ='请选择分摊方式'
            }else{
                let amt =0 ,v_mth =''
                //获取 方式中文名称
                this.feeArr.some(item=>{
                    if (item['CODE']==this.feeMth){
                        v_mth =item['CNAME']
                    }
                })
                this.dtlData.forEach(item=>{
                    if (item['ISOK']=='Y'){
                        amt =Number(amt)+Number(item['CHKAMT'])
                    }
                })           
                if(amt>0){
                    //默认按金额比例分摊 费用
                    let sum =0  //总金额
                    if (this.feeMth=='230800') { //按价格
                        this.listData.forEach(item=>{
                            sum=Number(sum)+Number(item['PRC'])
                        })
                        if (sum >0){
                            this.listData.forEach((item,index)=>{
                                if (Number(item['PRC'])>0 ){
                                    let v_disamt =Number(amt *Number(item['PRC']/Number(sum))).toFixed(2)
                                    let v_amt = (v_disamt/Number(item['QTY'])).toFixed(2)
                                    this.listData.splice(index,1,  Object.assign(item ,{DISMTH:v_mth,DISAMT:v_disamt,AMT:v_amt}) )
                                }
                            })
                        }
                    }else if (this.feeMth=='230801') { //按体积
                        this.listData.forEach(item=>{
                            sum=Number(sum)+Number(item['BOXCUBE']*item['QTY'])
                        })
                        if (sum >0){
                            this.listData.forEach((item,index)=>{
                                if (Number(item['BOXCUBE'])>0 ){
                                    let v_disamt =Number(amt *Number(item['BOXCUBE']*item['QTY']/Number(sum))).toFixed(2)
                                    let v_amt = (v_disamt/Number(item['QTY'])).toFixed(2)
                                    this.listData.splice(index,1,  Object.assign(item ,{DISMTH:v_mth,DISAMT: v_disamt,AMT:v_amt}) )
                                }
                            })
                        }
                    }else{  //按数量
                        this.listData.forEach(item=>{
                            sum=Number(sum)+Number(item['QTY'])
                        })
                        if (sum >0){
                            this.listData.forEach((item,index)=>{
                                if (Number(item['QTY'])>0 ){
                                    let v_disamt =Number(amt *Number(item['QTY']/Number(sum))).toFixed(2)
                                    let v_amt = (v_disamt/Number(item['QTY'])).toFixed(2)
                                    this.listData.splice(index,1,  Object.assign(item ,{DISMTH:v_mth,DISAMT:v_disamt,AMT:v_amt}) )
                                }
                            })
                        }
                    }
                    this.disWin=false
                }else{
                    this.disWin=false
                    this.promptWin =true
                    this.prompt ='没有费用需分摊，请核查'
                }
            }
        },
        //关联单据
        addList(){
            if (this.billType){ 
                this.tyArr.some(item=>{
                    if (item['CODE']== this.billType){
                        this.v_view =item['SUBNO']
                        this.v_type =item['CNAME']
                    }
                })
                if (this.v_view){
                    this.refWin =true
                    this.refData=[]
                    getTabColOrData(this.v_url,this.v_view,'','').then((res) => {
                        this.refData =res.result
                        this.$nextTick(() => { //有固定列时 查询后重新布局
                            this.$refs.refjoin.doLayout();
                        })
                    })
                }else{
                    this.promptWin =true
                    this.prompt ='此单据类型的数据源还未设置'
                }
            }else{
                this.promptWin =true
                this.prompt ='请选择单据类型'
            }
        },
        qryRefData(){
            let cond_=''
            if (this.selparam3 && this.textparam3){ //列1
                if (this.oper3==='like'){
                    cond_=cond_+' and  '+this.selparam3+'  like  \'%' + this.textparam3+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam3  +this.oper3+' \''+this.textparam3+'\' '
                }
            }
            getTabColOrData(this.v_url,this.v_view,'','','','','','',cond_).then((res) => {
                this.refData =res.result
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.refjoin.doLayout();
                })
            })
        },
        //新增费用
        addDtl(){
            this.dtlFlag='create'
            this.dtlCol={ISOK:'Y',CRCY:'人民币'}
            this.dtlWin =true
        },
        dtlEdit(row ,index){
            this.dtlCol=JSON.parse(JSON.stringify(row))
            this.dtlWin=true
            this.dtlFlag='edit'
            this.rowIndex=index
        } ,
        dtlSave(){
            this.notDtl.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.dtlCol[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool) {
                this.dtlWin =false
                if (this.dtlFlag==='edit' ){ //编辑时要替换数组记录
                    this.dtlData.splice(this.rowIndex,1,this.dtlCol)
                }else{
                    this.dtlData.push(this.dtlCol)
                }
            }
            this.$nextTick(() => { //有固定列时 查询后重新布局
                this.$refs.dtlref.doLayout();
            })
        },
        dtlDel(row,index){
            this.$confirm('你确定要删除此记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.dtlData.splice(index,1)
                if (row['IDSEQ'] && row['LSTSEQ']){
                    this.delArr.push(row)
                }
            }).catch(()=>{})
        },
        listDel(row,index){
            this.$confirm('你确定要删除此记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.listData.splice(index,1)
                if (row['IDSEQ'] && row['LSTSEQ']){
                    this.delData.push(row)
                }
            }).catch(()=>{})
        },
        tabDel(row,index){
            this.$confirm('你确定要删除此记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                //先删除分摊表
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row['IDSEQ'], p_table:'fin_feelist'},
                }).then(res=>{    
                    //再删除明细表  
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/delTabRec',
                        data: {p_key:'idseq',p_value:row['IDSEQ'], p_table:'fin_feedtl'},
                    }).then(res=>{
                        //最后删除主表
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/delTabRec',
                            data: {p_key:'idseq',p_value:row['IDSEQ'], p_table:'fin_fee'},
                        }).then(res=>{
                            this.qryTabData()
                        })
                    })      
                }) 
            }).catch(()=>{})
        },
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'227450',p_cond:' and lstseq in (1,2,3)' ,p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //表行点击事件
        rowClick(row){
            this.v_idseq =row['IDSEQ']
            
            if (row['STFG']==='Y')  {  
                this.stfgColor='color:green'
                this.stfgCss='icon-yishenhe1'
            }else if (row['STFG']==='X')  {  
                this.stfgColor='color:red'
                this.stfgCss='icon-yizuofei'
            }else{
                this.stfgColor='color:gray'
                this.stfgCss='icon-weishenhe3'
            }
        },
        //查询明细数据
        getDtlData(idseq){
            this.dtlData=[]
            getTabColOrData(this.v_url,'V_FIN_FEEDTL','idseq',idseq).then((res) => {
                this.dtlData =res.result  
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.dtlref.doLayout()
                })
            })
        },
        getItmData(idseq){
            this.listData=[]
            getTabColOrData(this.v_url,'V_FIN_FEElist','idseq',idseq).then((res) => {
                this.listData =res.result  
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.listref.doLayout();
                })
            })
        },
        //查询
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%' + this.txtparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam +this.oper+'\''+this.txtparam+'\''
                }
            }
 
            if (this.notAcc=='N'){
                cond_=cond_+ ' and idseq in (select idseq from V_FIN_FEEDTL where stfg=\'Y\' and payidno is null)'
            }else if (this.notAcc=='Y'){
                cond_=cond_+ ' and idseq in (select idseq from V_FIN_FEEDTL where stfg=\'Y\' and payidno is not null)'
            }else if (this.notAcc=='C'){
                cond_=cond_+ ' and idseq not in (select idseq from V_FIN_FEEDTL where stfg=\'Y\' and payidno is not null)'
            }
            this.getFeeList( cond_ )
        },
        getTabList(v_cond){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%' + this.txtparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam +this.oper+'\''+this.txtparam+'\''
                }
            }
 
            if (this.notAcc=='N'){
                cond_=cond_+ ' and idseq in (select idseq from V_FIN_FEEDTL where stfg=\'Y\' and payidno is null)'
            }else if (this.notAcc=='Y'){
                cond_=cond_+ ' and idseq in (select idseq from V_FIN_FEEDTL where stfg=\'Y\' and payidno is not null)'
            }else if (this.notAcc=='C'){
                cond_=cond_+ ' and idseq not in (select idseq from V_FIN_FEEDTL where stfg=\'Y\' and payidno is not null)'
            }
            this.getFeeList( cond_ +v_cond)
        },
        editRec(row,val){
            if (row['STFG']=='Y'||val=='Y'){
                this.saveFlag=true
            }else{
                this.saveFlag=false
            }
            this.v_stfg =row['STFG']
            this.addWin =true
            this.formCol =JSON.parse(JSON.stringify(row))
            this.getDtlData(row['IDSEQ']) 
            this.getItmData(row['IDSEQ'])
            this.delArr =[]
            this.v_commit =true
            if (row['HAPPEN']=='407503'){
                this.hapBool =true
            }else{
                this.hapBool =false
            }
        },

        cfmSet(val){
            this.$confirm('你确定要'+(val=='Y'?'审核':'弃审')+'此记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                var vm=this,cond_=''
                if (val==='Y'){
                    this.saveFlag=true
                    cond_=' set stfg=\'Y\' ,chkdttm=\''+getDate('full')+'\' ,chkuser=\''+this.v_username+'\''
                }else{
                    this.saveFlag=false
                    cond_=' set stfg=\'N\' , chkdttm=null  , chkuser=null'
                }
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:this.formCol['IDSEQ'],p_table:'FIN_FEE',p_cond: cond_},
                }).then(res=>{              
                    this.qryTabData() 
                    this.addWin=false          
                }) 
            }).catch(()=>{})          
 
        },
        //状态审核
        recSet(row, val,text){
            this.d_stfg=true
            let v_ok =false
            if( text=='弃审'){
                if (this.v_usernm !==row['CHKUSER']){
                    v_ok =true
                }
            }
            if (v_ok){
                this.promptWin =true
                this.prompt ='当前用户:'+this.v_usernm+' 与审核用户：'+row['CHKUSER']+' 不同时不能弃审'
            }else{
                this.$confirm('你确定要'+text+'此记录吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    let v_bool =true
                    if (val=='K' && row['HAPPEN']=='407503'){
                        if (!row['STKNO']){
                            v_bool =false
                            this.promptWin =true
                            this.prompt ='已审核的入库单不能为空'
                        }else if (!row['FINVNO']){
                            v_bool =false
                            this.promptWin =true
                            this.prompt ='对账单上的发票号码不能为空'
                        }
                    }else if (val=='K' && row['ISTAX']=='Y'){ //含税 需要发票
                        if (!row['FINVNO'] && row['DISTY']!=='228808'){ //分摊类型不是 OKR 需用预算及管控
                            v_bool =false
                            this.promptWin =true
                            this.prompt ='对账单上的发票号码不能为空'
                        }
                    }
                    if (v_bool) {
                        let v_cond ='' ,v_chkdttm='',v_chkuser='',v_cfmdttm='',v_cfmuser=''
                        if (val =='K') {
                            if(text=='弃审'){
                                v_cfmdttm =''
                                v_cfmuser =''
                            }else{
                                v_cfmdttm =getDate('full')
                                v_cfmuser =this.v_usernm
                            }
                            v_cond =' set stfg=\''+val+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\',chkuser=null,chkdttm=null'
                        }else if (val =='Y'){
                            v_chkdttm =getDate('full')
                            v_chkuser =this.v_usernm
                            v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
                        }else{
                            v_chkuser='',v_chkdttm='',v_cfmuser='',v_cfmdttm=''
                            v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\''
                        }
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/updateRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'FIN_FEE',p_cond: v_cond},
                        }).then(res=>{      
                            if(res.code =='200')  {           
                                //this.qryTabData()    
                                if (val =='Y'){
                                    Object.assign(row,{STFGNM:text ,STFG:val, APPUSER:v_cfmuser,APPDTTM:v_cfmdttm})
                                }else{
                                    Object.assign(row,{STFGNM:text ,STFG:val,CHKUSER:v_chkuser,CHKDTTM:v_chkdttm,APPUSER:v_cfmuser,APPDTTM:v_cfmdttm,ISCHK:val=='K'?'Y':'N'})
                                } 
                            }else{
                                this.promptWin=true
                                this.prompt=res.result
                            }        
                        }) 
                        //发起审批时
                        if (val =='K'){
                            // 调用工作流启动函数
                            startWorkflowInstance({
                                flowId: '227450',
                                businessId: row.IDSEQ, // 使用文件ID作为业务单据ID
                                actualInitiator: {empnm:this.v_usernm,empno:this.v_username,corpid:this.v_corpid},
                                component: this,
                                axios: this.$axios,
                                baseUrl: '',
                                // 微信消息相关参数
                                docType: '报销-管理摊分', // 单据类型
                                DIRNM: row.EMPNM, // 项目名称，使用文件名
                                CNAME: row.REASON,
                                businessData: {
                                    flowType: 3,
                                    qty: null,
                                    amt: row['TTLAMT'],
                                },
                                jumpUrl: window.location.href // 跳转URL，使用当前页面地址
                            })
                            this.d_stfg=false
                        }else if( text=='弃认'){ // 要把  SYS_FLOW_APPUSER 的状态为P 改为N
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/updateRec',
                                data: {p_key:'IDSEQ',p_value:row['IDSEQ'],p_table:'SYS_FLOW_APPUSER',p_cond:' set stfg=\'N\'',p_where:' and stfg=\'P\''},
                            }).then(res=>{
                                // 在日志表中 插入 一条 弃认记录
                                let v_obj={IDSEQ:row['IDSEQ'],LSTSEQ:'',EMPNO:this.v_username,EMPNM:this.v_usernm,APPDTTM:getDate('full'),STFG:'N',LOGTY:'R',RMK:'发起人 弃认'}
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/tableBodySave',
                                    data: {p_json:JSON.stringify(v_obj), p_table:'SYS_FLOW_APPLOG' },
                                }).then(res=>{  
                                    this.d_stfg=false 
                                })
                            })
                        }else if( text=='弃审'){ // 要把  SYS_FLOW_APPUSER 的状态为P 改为N
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/updateRec',
                                data: {p_key:'IDSEQ',p_value:row['IDSEQ'],p_table:'SYS_FLOW_APPUSER',p_cond:' set stfg=\'N\'',p_where:' and stfg=\'Y\' and iscc=0'},
                            }).then(res=>{
                                // 在日志表中 插入 一条 弃认记录
                                let v_obj={IDSEQ:row['IDSEQ'],LSTSEQ:'',EMPNO:this.v_username,EMPNM:this.v_usernm,APPDTTM:getDate('full'),STFG:'N',LOGTY:'R',RMK:'发起人 弃审'}
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/tableBodySave',
                                    data: {p_json:JSON.stringify(v_obj), p_table:'SYS_FLOW_APPLOG' },
                                }).then(res=>{   
                                    this.d_stfg=false
                                })
                            })
                        }else{
                            this.d_stfg=false
                        }
                    }
                }).catch(()=>{})
            
            }
        },
        //fee 明细
        getFeeList(cond){
            //获取所有产品记录且初始化分页记录  PAYSRC']=='433336'  
            this.loading =true     
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'PAYSRC', p_value:'433336',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+' order by '+this.selparam +' desc' ,p_table:'V_FIN_FEE'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage()
                    this.loading =false
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.tabref.doLayout()
                })
            }) 
        },
 
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            return row.IDSEQ+'-'+row['LSTSEQ']
        },
        getListKey(row){
            return row.REFIDSEQ+'-'+row['REFLSTSEQ'] 
        },
        getRefKey(row){
            return row.IDSEQ+'-'+row['LSTSEQ'] 
        },
        //新增 
        addRec(){
            this.addWin=true
            this.addFlag='create'
            this.saveFlag=false
            this.formCol={DTTM:getDate(),STFG:'N',ISTAX:'Y',PAYSRC:'433336'}
            this.dtlData=[]
            this.listData=[]
            this.v_commit =true
        },
        //保存记录
        saveRec(){
            var vm =this 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.formCol[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool && this.v_commit) {    
                let obj_ ={}    
                Object.assign(obj_,this.formCol,{ 'CORPID':this.v_corpid,STFG:'N'}) 
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(obj_), p_table:'FIN_FEE',frmid:'227450'},
                }).then(res=>{      
                    if(res.result ==='OK')  {
                        this.v_commit =false
                        let v_idseq =res.idseq
                        //报销明细保存：批量保存  res.idseq
                         this.$axios({   
                            method: 'post',
                            url:'xuper_auth/batDtlSave2',
                            data: {p_json:JSON.stringify(this.dtlData), p_table:'FIN_FEEdtl',p_idseq:v_idseq,p_action:'S' },
                         }).then(res=>{
                             if (res.code!=='200'){
                                 this.promptWin=true
                                 this.prompt=res.result
                             }
                         })
                         //明细删除
                         if (this.delArr.length>0) {
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.delArr), p_table:'FIN_FEEdtl',p_idseq:v_idseq,p_action:'D' },
                            })
                         }   
                        //费用摊分保存：批量保存 
                         this.$axios({   
                            method: 'post',
                            url:'xuper_auth/batDtlSave2',
                            data: {p_json:JSON.stringify(this.listData), p_table:'FIN_FEELIST',p_idseq:v_idseq,p_action:'S' },
                         }).then(res=>{
                             if (res.code!=='200'){
                                 this.promptWin=true
                                 this.prompt=res.result
                             }
                         })
                        //  费用删除
                         if (this.delData.length>0) {
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.delData), p_table:'FIN_FEElist',p_idseq:v_idseq,p_action:'D' },
                            })
                         } 
                
                        vm.addWin =false   
                        vm.chkChg(this.notAcc)
                    }else{
                        this.v_commit =true
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
            }
 
        },
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','227450','lstseq','2','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','227450','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','227450','lstseq','3','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.listArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','227450','lstseq','4','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.refArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .oneMenu{
        line-height:35px;
        text-align:left;
        padding-left:35px;
        font-size:14px;
        color:white;
        background-color: #409eff;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#f4f6f8;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        color:#409EFF;
    }
    .item-width2  {
        width: 97%;
    }
    .active { 
        color:#D200D2; 
    } 
 
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table__body {
        width: 100%;
        // 使表格兼容safari，不错位
        table-layout: fixed !important;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 3px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
 